import { Tooltip } from '@mui/material';
import React from 'react';

const getGrayIconFullPath = (iconName: string): string => {
  return `/assets/icons/gray-bg/${iconName}.svg`;
};

export const ROUTE_CELL_ICON_PATHS = {
  quantity: getGrayIconFullPath('quantity'),
  'date-range': getGrayIconFullPath('date-range'),
  collateral: getGrayIconFullPath('collateral'),
  risk: getGrayIconFullPath('risk'),
  settlement: getGrayIconFullPath('settlement'),
  flexibility: getGrayIconFullPath('flexibility'),
  shipment: getGrayIconFullPath('shipment'),
  fullGuarantee: getGrayIconFullPath('fullGuarantee'),
  carbon_footprint: getGrayIconFullPath('carbon_footprint'),
  physical_delivery: getGrayIconFullPath('physical delivery'),
};

export const RouteIconCell: React.FC<RouteIconCellProps> = ({ routeIconCellData }) => {
  return (
    <div className="flex overflow-x-auto gap-1.5">
      {routeIconCellData.map((item, index) => (
        <Tooltip title={item.toolTipText} key={index}>
          <div className="flex  flex-row p-[0.6rem] space-x-1 items-center rounded bg-gray-50 min-w-fit">
            <img className="w-[1.75rem] h-[1.75rem]" src={item.iconPath} alt={item.iconText} />
            {item.iconText && <div className="text-sm whitespace-nowrap">{item.iconText}</div>}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};
export interface IRouteIconCell {
  iconPath: string;
  iconText?: string;
  toolTipText: string;
}
interface RouteIconCellProps {
  routeIconCellData: IRouteIconCell[];
}
